import React, { useState, useContext } from 'react';
import { ScrollingPopup, ShowConfirmPopup } from 'components/common/popup/popup';
import SiteSelector from './siteSelector';
import SiteService from 'services/siteService';
import Inputs from 'components/inputs/inputs';
import AuthContext from 'contexts/authContext';

export default function SiteSelectorModal(props) {
  const { authState } = useContext(AuthContext);

  const [filterString, setFilterString] = useState('');
  const [oldShowValue, setOldShowValue] = useState(props.show);
  const [tempSelection, setTempSelection] = useState([]);

  const { areaId, areaName } = props;
  const siteSelector = React.createRef();

  if (oldShowValue !== props.show) {
    setOldShowValue(props.show);
    if (props.show) {
      setTempSelection(props.sitesSelected || []);
    }
  }

  const onChangeSelection = (newValues) => {
    setTempSelection(newValues);
    siteSelector.current.changeSelection(newValues);
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const applySitesClicked = () => {
    props.onChange(tempSelection);
    if (props.onClose) {
      props.onClose();
    }
  };

  const cancelSitesClicked = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const clearSitesClicked = () => {
    setTempSelection([]);
    siteSelector.current.changeSelection([]);
  };

  const onDownloadSelections = async () => {
    const savedSelections = await SiteService.API.getSavedSitesList({ areaId, areaName });
    if (savedSelections.length > 0) {
      ShowConfirmPopup({
        title: 'Confirm',
        message: <div>Do you want to override your selections with your saved list of {savedSelections.length} sites?</div>,
        onAccept: () => {
          onChangeSelection(savedSelections);
        }
      });
    }
  };

  return (
    <ScrollingPopup
      className={props.className}
      title={props.isSingleSelect ? 'Select Site' : 'Select Sites'}
      show={props.show}
      onClose={handleClose}
      leftIconClass={(areaId || areaName) ? 'icons8-output' : ''}
      onLeftIconClick={onDownloadSelections}
      header={
        <Inputs.Text.Throttled
          placeholder='Search'
          value={filterString}
          onValueChange={(value) => setFilterString(value.toLowerCase())}
          isInvalid={filterString.length > 0 && filterString.length < 3}
          debounceDelay={400}
        />
      }
      footer={
        <div className='d-flex justify-content-between align-items-center w-100'>
          {props.isSingleSelect ? (
            <div>
            </div>
          ) : (
              <div>
                <span className='badge badge-success'>{tempSelection.length} Selections</span>
                <Inputs.Button variant='hover-default' size='sm' className='ml-2' onClick={clearSitesClicked} label='Clear' iconClass='icons8-delete' />
              </div>
            )}
          <div>
            <Inputs.Button variant='default' onClick={cancelSitesClicked} iconClass='icons8-undo' label='Cancel' />
            <Inputs.Button variant='app' onClick={applySitesClicked} iconClass='icons8-checkmark' label='Apply' />
          </ div>
        </div>
      }
    >
      <SiteSelector
        ref={siteSelector}
        hierarchy={authState.hierarchy}
        onChangeSelection={onChangeSelection}
        sitesSelected={tempSelection}
        filterString={filterString}
        isSingleSelect={props.isSingleSelect}
        selectableFn={props.selectableFn}
      />
    </ScrollingPopup>
  );
}
